import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

// The bare /admin_workflows/submission_templates/:id URL (e.g. old
// bookmarks/links) redirects to the Editor tab of the template workspace.
const SubmissionTemplateEditRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  if (!id) return null;

  return (
    <Navigate to={`/admin_workflows/submission_templates/${id}/edit`} replace />
  );
};

export default SubmissionTemplateEditRedirect;
